import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@NgModule({
    declarations: [SpinnerComponent],
    imports: [
        CommonModule,
        NgxUiLoaderModule
    ],
    exports: [SpinnerComponent]
})
export class SpinnerModule { }
